/*
 *
 * Tracking constants
 *
 */

export const FILTERS_WATCHER = "app/Tracking/FILTERS_WATCHER"
export const FILTERS_FAILED = "app/Tracking/FILTERS_FAILED"
export const FILTERS_SUCCESS = "app/Tracking/FILTERS_SUCCESS"

export const GET_PLANS_WATCHER = "app/Tracking/GET_PLANS_WATCHER"
export const GET_PLANS_FAILED = "app/Tracking/GET_PLANS_FAILED"
export const GET_PLANS_SUCCESS = "app/Tracking/GET_PLANS_SUCCESS"

export const DEFAULT_ACTION = "app/Tracking/DEFAULT_ACTION"

export const GET_TEMPLATE_WATCHER = "app/Tracking/GET_TEMPLATE_WATCHER"
export const GET_TEMPLATE_FAILED = "app/Tracking/GET_TEMPLATE_FAILED"
export const GET_TEMPLATE_SUCCESS = "app/Tracking/GET_TEMPLATE_SUCCESS"

export const GET_TEMPLATE_TASK_WATCHER =
  "app/Tracking/GET_TEMPLATE_TASK_WATCHER"
export const GET_TEMPLATE_TASK_SUCCESS =
  "app/Tracking/GET_TEMPLATE_TASK_SUCCESS"
export const GET_TEMPLATE_TASK_FAILED = "app/Tracking/GET_TEMPLATE_TASK_FAILED"

export const GET_SURVEYS_WATCHER = "app/Tracking/GET_SURVEYS_WATCHER"
export const GET_SURVEYS_FAILED = "app/Tracking/GET_SURVEYS_FAILED"
export const GET_SURVEYS_SUCCESS = "app/Tracking/GET_SURVEYS_SUCCESS"
